<template>
  <div class="general">
    <Helmet>
      <title>General Contact - inte-QT</title>
      <meta name="title" content="General Contact - inte-QT" />
      <meta name="description" content="General support for any type of inquiry" />
      <link rel="canonical" href="https://www.inte-qt.com/contact/general" />
    </Helmet>

    <h1 class="mx-auto center-header text-center general__title">General</h1>

    <form @submit.prevent="sendEmail" class="general__form mx-auto" ref="formRef">
      <div class="mb-3 general__box">
        <label for="company-name" class="form-label">Company Name</label>
        <input
          type="text"
          id="company-name"
          class="form-control"
          v-model="form.company_name"
          name="company_name"
          required
        />
      </div>

      <div class="mb-3 general__box">
        <label for="name" class="form-label">Full Name</label>
        <input
          type="text"
          id="name"
          class="form-control"
          v-model="form.name"
          name="name"
          required
        />
      </div>

      <div class="mb-3 general__box">
        <label for="email" class="form-label">Email Address</label>
        <input
          type="email"
          id="email"
          class="form-control"
          v-model="form.email"
          name="email"
          required
        />
        <div id="emailHelp" class="form-text">
          We'll never share your email or phone number with anyone else.
        </div>
      </div>

      <!-- Phone Input -->
      <div class="mb-3 general__box">
        <vue-tel-input
          v-model="form.phone"
          :default-country="'ES'"  
          placeholder="Enter phone number"
          input-class="form-control"
          name="phone"
          required
        />
      </div>

      <div class="mb-3 general__box">
        <label for="message" class="form-label">How can we support you?</label>
        <textarea
          id="message"
          class="form-control"
          rows="5"
          v-model="form.message"
          name="message"
          required
        ></textarea>
      </div>

      <div class="form-check mb-3 general__box">
        <input
          class="form-check-input"
          type="checkbox"
          id="agree"
          v-model="form.agreed"
          required
        />
        <label class="form-check-label" for="agree">
          Agree to terms and conditions of the
          <router-link to="/privacy-policy">privacy policy</router-link>.
        </label>
      </div>

      <div class="text-center">
        <button type="submit" class="button">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';

export default {
  name: 'GeneralPage',
  
  setup() {
    const formRef = ref(null);
    const form = ref({
      company_name: '',
      name: '',
      email: '',
      phone: '',
      message: '',
      agreed: false,
    });

    const sendEmail = () => {
      if (!form.value.agreed) {
        Swal.fire({
          icon: 'info',
          title: 'Wait',
          text: 'You need to agree to terms and conditions.',
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
        return;
      }

      emailjs
        .sendForm(
          'service_cxy3wvs',
          'template_qfce9va',
          formRef.value,
          'XTHb8nGPkWwJjz2yf'
        )
        .then(() => {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'We have received your form. We will get back to you soon.',
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
          formRef.value.reset();
          Object.assign(form.value, {
            company_name: '',
            name: '',
            email: '',
            phone: '',
            message: '',
            agreed: false,
          });
        })
        .catch(() => {
          Swal.fire({
            icon: 'error',
            title: 'Oops',
            text: 'There was an error sending your message. Please try again later.',
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        });
    };

    return {
      form,
      sendEmail,
      formRef,
    };
  },
};
</script>

<style scoped>
@import 'vue3-phone-number-input/dist/vue3-phone-number-input.css';

.general__form {
  margin: 3rem 1rem;
  width: 700px;
}

.general__box {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.general__box textarea,
.general__box select {
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  box-sizing: border-box;
  margin-top: 0.25rem;
}

.form-label {
  font-family: "Poppins", sans-serif;
  font-size: 1.125rem;
  font-weight: 300;
  color: #212529;
  margin-bottom: 0;
  line-height: 1.5;
}

.form-text {
  font-family: "Poppins", sans-serif;
  font-size: 1.125rem;
  font-weight: 300;
  color: #6c757d;
  margin-top: 0.25rem;
}

.form-check {
  display: table-row-group;
  font-family: "Poppins", sans-serif;
  font-size: 1.125rem;
  font-weight: 300;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}

.form-check-input {
  width: 1em;
  height: 1em;
  margin-top: .25em;
  appearance: none;
  background-color: #fff;
  border: 1px solid #ccc;
}

.form-check-label {
  margin-left: 2rem;
  font-size: 1rem;
  color: #333;
  cursor: pointer;
  line-height: 1.5;
}

.form-check-input:checked + .form-check-label {
  color: #007bff;
}

.form-check-input:focus {
  border-color: #80bdff;
  outline: none;
  box-shadow: 0 0 0 0.25rem rgba(38, 143, 255, 0.25);
}

.button {
  background-color: #007bff;
  border: none;
  color: #fff;
  padding: 0.75rem 2rem;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.2s ease;
}

.button:hover {
  background-color: #0056b3;
}

.text-center {
  text-align: center;
  margin-top: 20px;
}

.general__title {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 30px;
}

@media (max-width: 768px) {
  .general__form {
    padding: 1.5rem;
  }

  .general__box {
    width: 100%;
  }

  .button {
    width: 100%;
    padding: 0.75rem;
  }
}
</style>
